import { useState, useEffect } from 'react';
import {
  TwitterShareButton,
  FacebookShareButton,
  EmailShareButton,
} from 'react-share';
import { Stack } from '@mui/material';

import { TwitterIcon, FacebookSymbolIcon, EmailIcon } from '@/components/icons';
import { Resource } from '@/types/Content/Resources';
import Icon from '@/components/icons/Icon';
import {
  SocialShareItemLabel,
  shareButtonStyles,
  Wrapper,
  ToCommentsButton,
} from './SocialShare.styles';

interface SocialShareProps extends Pick<Resource, 'title' | 'seo'> {
  className?: string;
  order?: Array<string>;
  hideLabel?: boolean;
  commentCounter?: number;
  toCommentsClick?: () => void;
}

function SocialShare({
  className,
  order,
  title,
  seo,
  hideLabel,
  commentCounter,
  toCommentsClick,
}: SocialShareProps): JSX.Element {
  const [url, setUrl] = useState('');
  const { title: seoTitle, description: seoDescription } = seo ?? {};
  const emailProps = {
    subject: seoTitle || title || '',
    body: seoDescription || '',
  };
  const Component = {
    facebook: () => (
      <FacebookShareButton url={url} css={shareButtonStyles.button}>
        <FacebookSymbolIcon />
        <SocialShareItemLabel hide={hideLabel}>Post</SocialShareItemLabel>
      </FacebookShareButton>
    ),
    twitter: () => (
      <TwitterShareButton url={url} css={shareButtonStyles.button}>
        <TwitterIcon />
        <SocialShareItemLabel hide={hideLabel}>Tweet</SocialShareItemLabel>
      </TwitterShareButton>
    ),
    email: () => (
      <EmailShareButton
        url={url}
        {...emailProps}
        css={shareButtonStyles.button}
      >
        <EmailIcon />
        <SocialShareItemLabel hide={hideLabel}>Email</SocialShareItemLabel>
      </EmailShareButton>
    ),
    toComments: () =>
      toCommentsClick ? (
        <ToCommentsButton onClick={toCommentsClick}>
          <Stack alignItems="center">
            <Icon iconName="comments" />
            <SocialShareItemLabel hide={hideLabel}>
              Comments{commentCounter && ` (${commentCounter})`}
            </SocialShareItemLabel>
          </Stack>
        </ToCommentsButton>
      ) : null,
  };
  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  return (
    <Wrapper className={className}>
      {order.map((media) => Component[media]())}
    </Wrapper>
  );
}

SocialShare.defaultProps = {
  className: '',
  order: ['twitter', 'facebook', 'email', 'toComments'],
  hideLabel: false,
  commentCounter: undefined,
  toCommentsClick: undefined,
};

export default SocialShare;
